<template>
  <div>
    <div id="core" v-show="showType == 1"></div>
    <div id="design" v-show="showType == 2" :style="`background: url(${'https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/' + effectImageHrss});background-size: 100% 100%;`"></div>
    <div class="bottom_bar">
      <div class="lv_flex">
        <div class="lv_flex_1" @click="reflash">刷新</div>
        <div class="lv_flex_1" @click="show = true">信息</div>
      </div>
    </div>
    <div class="view-bar" @click="changeShowType">
      <template v-if="showType == 2">
        <img src="@/assets/design.png">
        <div>效果图</div>
      </template>
      <template v-if="showType == 1">
        <img src="@/assets/3D.png">
        <div>3D</div>
      </template>
    </div>
    <div class="scale-bar">
      <div class="mr-38" @click="changeScale(-25)">-</div>
      <div @click="changeScale(25)">+</div>
      <div class="percent">{{sliderValue}}%</div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="share_pop">
        <van-field v-model="form.name" label="作品名称" readonly />
        <van-field v-model="form.userName" label="创作作者" readonly />
        <van-field
          v-if="form.flowers"
          v-model="form.flowers"
          label="使用花材"
          autosize
          readonly
          type="textarea"
        />
        <van-field
          v-if="form.container"
          v-model="form.container"
          label="使用器皿"
          readonly
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Editor } from "../../../3D-editor/index";
import { login } from "@/plugins/utils.js";
const { getFlowerUseMaterials } = require("@/utils/artworkMaterials");
let editor;
export default {
  mounted() {
    login(() => {
      editor = new Editor({
        dom: "core",
        plat: "mobile",
        readOnly: true,
      });

      if (
        this.$store.state.routeParams.productId ||
        this.$route.query.productExpandId
      ) {
        this.getData(
          this.$store.state.routeParams.productId ||
            this.$route.query.productExpandId
        );
      }
    }, this);
  },
  methods: {
    changeShowType() {
      this.showType = this.showType == 1 ? 2 : 1;
    },
    changeScale(val){
      if (this.sliderValue + val === 0 || this.sliderValue + val === 225) {
        return;
      }
      this.sliderValue += val;
      if (this.showType == 1) {
        editor.setZoom(this.sliderValue / 100);
        return;
      } else {
        const designElement = document.getElementById('design');
        if (designElement) {
          designElement.style.transform = `scale(${this.sliderValue / 100})`;

        }
      }
      
    },
    reflash() {
      if (this.showType == 1) {
        editor.setAngle({
          x: this.lateralAxis,
          y: this.verticalAxis,
        });
      } else {
        const designElement = document.getElementById('design');
        if (designElement) {
          this.sliderValue = 100;
          designElement.style.transform = `scale(1)`;
        }
      }
    },
    getData(id) {
      let url = "/product/getById";
      let params = {
        id,
        type: this.$route.query.type || 2,
      };
      if (this.$route.query.productExpandId) {
        url = "/product/expand/getById";
        params = {
          productExpandId: this.$route.query.productExpandId,
          type: this.$route.query.type || 2,
        };
      }

      this.$ajax
        .get(url, {
          params,
        })
        .then((res) => {
          document.title = res.data.name;
          let dataJson = JSON.parse(res.data.dataJson);
          this.lateralAxis = parseInt(dataJson.angle.x);
          this.verticalAxis = parseInt(dataJson.angle.y);
          const useMaterials = res.data.useMaterials || [];
          this.form = {
            name: res.data.name,
            userName: res.data.userName,
            flowers: getFlowerUseMaterials(useMaterials)
              .map((item) => {
                return `${item.materialName}（${item.count}朵）`;
              })
              .join("\n"),
            container: dataJson.objects.container
              ? dataJson.objects.container.resourceName
              : "",
          };
          this.effectImageHrss = res.data.effectImageHrss || '';
          editor.load(dataJson);
          this.reflash();
        });
    },
  },
  data() {
    return {
      sliderValue: 100,
      lateralAxis: 0,
      verticalAxis: 0,
      show: false,
      id: "",
      form: {
        name: "",
        userName: "",
        flowers: "",
        container: "",
      },
      showType: 1,
      effectImageHrss: '',
    };
  },
};
</script>

<style lang="scss" scoped>

.mr-38{
  margin-right: rem(38);
}
#design {
  width: 100vw;
  height: 100vh;
  // background-size: 100% 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.3s ease;
  // overflow: hidden;
}
.view-bar{
  position: fixed;
  bottom: rem(200);
  left: rem(20);
  // width: rem(120);
  height: rem(67);
  padding: 0 rem(18);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #DCDCDC;
  border-radius: 2px;
  font-size: rem(28);
  font-weight: 100;
  img {
    width: rem(35);
    height: rem(35);
    padding-right: rem(17);
  }
}
.scale-bar{
  position: fixed;
  bottom: rem(116);
  left: rem(20);
  width: rem(240);
  height: rem(67);
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #DCDCDC;
  border-radius: 2px;
  font-size: rem(60);
  padding-left: rem(36);
  font-weight: 100;
}
.share_pop {
  padding: rem(30) 0;
}

.percent{
  font-size: rem(26);
  margin-left: rem(33);
  padding-left: rem(21);
  border-left: 1px solid #979797;;
}

#core {
  width: 100vw;
  height: 100vh;
}
.bottom_bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}
.lv_flex {
  padding: rem(12) rem(20);
  > div {
    line-height: rem(80);
    text-align: center;
    background: #6e9f21;
    color: #fff;
    font-size: rem(28);

    border-radius: rem(6);
    + div {
      margin-left: rem(20);
    }
  }
}
</style>
